import { render, staticRenderFns } from "./DocumentacionZone.vue?vue&type=template&id=8929405c&scoped=true&lang=true&"
import script from "./DocumentacionZone.vue?vue&type=script&lang=js&"
export * from "./DocumentacionZone.vue?vue&type=script&lang=js&"
import style0 from "./DocumentacionZone.vue?vue&type=style&index=0&id=8929405c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8929405c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
